"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (input) {
    var output;
    var parts = input.split('.');
    var identifier = parts.shift();
    var domain = parts.shift();
    if (domain === 'wpcdn' && identifier) {
        output = "cph_".concat(identifier);
    }
    return output;
});
